import { useEffect, useMemo, useState, type ReactNode } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../../shared/lib/firebase';
import { useAuth } from '../auth/useAuth';
import { LicenseContext } from './LicenseContext';
import { buildLicenseApi } from './useLicense';

/** UM listener em system_settings/license. Erro/ausente/invalido => tela de sempre (nunca trava). */
export function LicenseProvider({ children }: { children: ReactNode }) {
  const { status } = useAuth();
  const [data, setData] = useState<unknown>(null);
  const [loaded, setLoaded] = useState(false);
  const signedIn = status === 'signed-in';

  useEffect(() => {
    if (!signedIn) return;
    return onSnapshot(
      doc(db, 'system_settings/license'),
      (snap) => {
        setData(snap.exists() ? snap.data() : null);
        setLoaded(true);
      },
      (err) => {
        console.error('[license] snapshot error', err);
        setData(null);
        setLoaded(true);
      },
    );
  }, [signedIn]);

  const api = useMemo(() => buildLicenseApi(signedIn ? data : null, signedIn ? loaded : true), [signedIn, data, loaded]);
  return <LicenseContext.Provider value={api}>{children}</LicenseContext.Provider>;
}
